export const priorityColorObj: { [key: string]: string } = {
  low: "#94A3B8",
  medium: "#F59E0B",
  high: "#F43F5E",
};

export const ticketStatusConversion: {
  [key: string]: string;
} = {
  "Open Tickets": "open",
  "In Progress": "progress",
  Closed: "done",
};
